"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _reactVirtualized = require("react-virtualized");
var _constants = require("./constants");
var _helpers = _interopRequireDefault(require("./helpers"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var VirtualizedList = function VirtualizedList(_ref) {
  var children = _ref.children,
    item = _ref.item,
    listHeight = _ref.listHeight;
  return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, {
    disableHeight: true
  }, function (_ref2) {
    var width = _ref2.width;
    return listHeight && /*#__PURE__*/_react["default"].createElement(_reactVirtualized.List, {
      rowCount: R.length(item.list),
      width: width,
      height: (0, _helpers["default"])(item.list, listHeight),
      rowHeight: _constants.ROW_HEIGHT,
      rowRenderer: function rowRenderer(_ref3) {
        var index = _ref3.index,
          style = _ref3.style;
        return children && children({
          idx: index,
          style: style,
          subItem: R.path(['list', index], item)
        });
      },
      overscanRowCount: 3
    });
  });
};
VirtualizedList.propTypes = {
  children: _propTypes["default"].func.isRequired,
  item: _propTypes["default"].shape({
    list: _propTypes["default"].oneOf([_propTypes["default"].array])
  }).isRequired,
  listHeight: _propTypes["default"].number
};
VirtualizedList.defaultProps = {
  listHeight: null
};
VirtualizedList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VirtualizedList",
  "props": {
    "listHeight": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "item": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "list": {
            "name": "enum",
            "value": [{
              "value": "PropTypes.array",
              "computed": true
            }],
            "required": false
          }
        }
      },
      "required": true
    }
  }
};
var _default = VirtualizedList;
exports["default"] = _default;